export const createPointsConstants = {
	CREATE_POINTS: 'CREATE_POINTS',
	POINTS_CREATED: 'POINTS_CREATED'
}
